import { MolsonBox, MolsonSpinner } from '@components/reusable'
export const ModalGridLoader = () => {
  return (
    <MolsonBox
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 200,
        width: '100%'
      }}
    >
      <MolsonSpinner size={50} />
    </MolsonBox>
  )
}
